module.exports = __webpack_public_path__ + "static/media/swordofthedivine.49750928.png";